export const PREFIX = 'whizz';
export const ICON_WRAPPER = `${PREFIX}_icon`;
export const ICON_MATERIAL = `${ICON_WRAPPER}-material`;
export const ICON_MATERIAL_PERSIST_COLOR = `${ICON_WRAPPER}-material_persist-color`;
export const ICON_WHIZZ = `${ICON_WRAPPER}-whizz`;
export const ICON_STUDENT = `${ICON_WRAPPER}-student`;
export const ICON_STUDENT_BORDER = `${ICON_STUDENT}_border`;
export const ICON_STUDENT_BACKGROUND = `${ICON_STUDENT}_background`;
export const ICON_STUDENT_CHART = `${ICON_STUDENT}_chart`;
export const BUTTON_WRAPPER = `${PREFIX}_button`;
export const BUTTON_ICON_WRAPPER = `${PREFIX}_button-icon`;
export const BUTTON_TOGGLE = `${BUTTON_WRAPPER}_toggle`;
export const SELECTOR_WRAPPER = `${PREFIX}_selector`;
export const SELECTOR_ICON = `${SELECTOR_WRAPPER}-icon`;
export const SELECTOR_ICON_CLEAR = `${SELECTOR_ICON}_clear`;
export const SELECTOR_ICON_DROPDOWN = `${SELECTOR_ICON}_dropdown`;
export const SELECTOR_STUDENT_SEARCH = `${SELECTOR_WRAPPER}_search`;
export const SELECTOR_STUDENT_SEARCH_WITH_VALUE = `${SELECTOR_STUDENT_SEARCH}_has-value`;
export const SELECTOR_STUDENT_SEARCH_NO_BORDER = `${SELECTOR_STUDENT_SEARCH}_no-border`;
export const DROPDOWN_WRAPPER = `${PREFIX}_dropdown`;
export const ALERT_WRAPPER = `${PREFIX}_alert`;
export const LOADER_WRAPPER = `${PREFIX}_loader`;
export const LOADER_ANIMATION = `${LOADER_WRAPPER}-animation`;
export const LOADER_LABEL = `${LOADER_WRAPPER}-label`;
export const TABLE_WRAPPER = `${PREFIX}_table`;
export const TABLE_FOOTER = `${TABLE_WRAPPER}-footer`;
export const TABLE_SORT = `${TABLE_WRAPPER}-sort`;
export const TABS_WRAPPER = `${PREFIX}_tabs`;
export const TABS_CONTAINER = `${TABS_WRAPPER}-container`;
export const TABS_BUTTON = `${TABS_WRAPPER}-button`;
export const CHOICE_WRAPPER = `${PREFIX}_choice`;
export const CHOICE_RADIO = `${CHOICE_WRAPPER}-radio`;
export const CHOICE_CHECKBOX = `${CHOICE_WRAPPER}-checkbox`;
export const TOGGLE_WRAPPER = `${PREFIX}_toggle`;
export const TOGGLE_SLIDER = `${TOGGLE_WRAPPER}-slider`;
export const DATEPICKER_WRAPPER = `${PREFIX}_datepicker`;
export const DATEPICKER_RANGE = `${DATEPICKER_WRAPPER}-range`;
export const DATEPICKER_RANGE_2MONTHS = `${DATEPICKER_RANGE}_2months`;
export const MODAL_WRAPPER = `${PREFIX}_modal`;
export const MODAL_MASK = `${MODAL_WRAPPER}-mask`;
export const MODAL_CONTENT = `${MODAL_WRAPPER}-content`;
export const SWISHPANEL_WRAPPER = `${PREFIX}_swishpanel`;
export const SWISHPANEL_MASK = `${SWISHPANEL_WRAPPER}-mask`;
export const SWISHPANEL_CONTENT = `${SWISHPANEL_WRAPPER}-content`;
